export const HELP_DESK_APP_NAMESPACE = 'Help Desk App';